<template>
  <div
    id="noResultsTarget"
    class="hotel-offerings-container"
  >
    <div class="hotel-offerings" />
    <div class="hotel-offerings-desc">
      <h3 class="hotel-offerings-title">
        {{ $t('h4h.otherHotels') }}
      </h3>
      <p class="hotel-offerings-info">
        {{ $t('h4h.somethingDifferent') }}
      </p>
      <p class="hotel-offerings-disclaimer small">
        {{ $t('h4h.additionalHotelDisclaimer') }}
      </p>
    </div>
    <div
      class="btn btn-inverted"
      :class="this.$store.state.hotel.showRetailIndex ? 'hide-btn' : 'show-btn'"
      @click="showAdditionalHotels()"
    >
      {{ $t('h4h.showAdditionalHotels') }}
    </div>
  </div>
</template>

<script>
import mixin from './hotel_availability'
import { mapMutations } from 'vuex'

export default {
  mixins: [mixin],

  data(){
    return{
      hotels:[],
    }
  },

  methods:{
    ...mapMutations('hotel', ['showRetailIndex', 'setRetailLoading']),
    showAdditionalHotels() {
      const showRetail = this.$store.state.hotel.showRetailIndex
      if (showRetail) {
        this.showRetailIndex(!showRetail)
      } else {
        this.showRetailIndex(true)
        const el = document.getElementsByClassName('hotel-offerings-container')[0]
        setTimeout(() => {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }, 300)
      }
    },
  }

}
</script>
